export const AuthGradient = ({ children }: { children: React.ReactNode }) => {
  return (
    <div
      className="pt-11 pb-4 small:py-11 overflow-y-scroll max-h-[95vh] rounded-lg scrollbar-hidden 
  bg-gradient-to-b from-greyscale-almostBlack via-greyscale-dark to-greyscale-almostBlack">
      {children}
    </div>
  );
};
